const staticTreeData = [
    {
        title: 'Коэффициент измен. базового дебита',
        key: 'baseRateChangeFactor',
        code: 'baseRateChangeFactor',
        selectable: true,
    },
    {
        title: 'Коэффициент измен. прироста дебита ',
        key: 'coeffChangeGrowthFactor',
        code: 'coeffChangeGrowthFactor',
        selectable: false,
        keyNum: 2,
        children: [],
    },
    {
        title: 'Оценка фактической добычи',
        key: 'actualProductionEstimation',
        code: 'actualProductionEstimation',
        selectable: true,
    },
    {
        title: 'Оценка план. доб(польз.)',
        key: 'planProductionEstimation',
        code: 'planProductionEstimation',
        selectable: true,
    },
    {
        title: 'Оценка план. наг(польз.)',
        key: 'planInjectionEstimation',
        code: 'planInjectionEstimation',
        selectable: true,
    },
    {
        title: 'Детализация',
        key: 'detailing',
        selectable: false,
        code: 'detailing',
        keyNum: 1,
        children: [
            {
                title: 'Сводные дебиты / приросты',
                key: 'detailing.freeDebits',
                code: 'freeDebits',
                selectable: true,
            },
        ],
    },
];

export default staticTreeData;
